import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOnlineQuoteForm } from 'routes/online_quotes/content/onlineQuoteFormSlice';

const Segment2 = ({ agreeToTerms, handleAgreeToTerms, showErrors = false }) => {

  // REDUX HANDLING
  const dispatch = useDispatch()
  const onlineQuoteForm = useSelector((state) => state.onlineQuoteForm.value)

  const [numOfDependentsToRender, setNumOfDependentsToRender] = useState(1);

  const [formData, setFormData] = useState({
    package: '',
    age: '',
    spouseAge: '',
    tobaccoUser: '',
    medications: '',
    numberOfDependents: '',
    dependent1Age: '',
    dependent2Age: '',
    dependent3Age: '',
    dependent4Age: '',
    dependent5Age: '',
    dependent6Age: '',
    dependent7Age: '',
  });

  const dependents = [
    { label: 'Dependent 1 Age', name: 'dependent1Age', value: formData.dependent1Age },
    { label: 'Dependent 2 Age', name: 'dependent2Age', value: formData.dependent2Age },
    { label: 'Dependent 3 Age', name: 'dependent3Age', value: formData.dependent3Age },
    { label: 'Dependent 4 Age', name: 'dependent4Age', value: formData.dependent4Age },
    { label: 'Dependent 5 Age', name: 'dependent5Age', value: formData.dependent5Age },
    { label: 'Dependent 6 Age', name: 'dependent6Age', value: formData.dependent6Age },
    { label: 'Dependent 7 Age', name: 'dependent7Age', value: formData.dependent7Age }
  ]

  const [isIndividualChild, setIsIndividualChild] = useState(false);
  const [isIndividualChildren, setIsIndividualChildren] = useState(false);


  const handleInputChange = (e) => {
    const { name, value } = e.target;


    // PACKAGE CONDITIONS
    if (name === 'package' && value === 'Individual + Child') {
      setFormData(prevState => ({
        ...prevState,
        [name]: value,
        numberOfDependents: '1' // Set numberOfDependents to '1'
      }));
      setIsIndividualChild(true);
    } else if (name === 'package') {
      // If package is changed to anything other than 'Individual + Child', reset numberOfDependents
      setFormData(prevState => ({
        ...prevState,
        [name]: value,
        numberOfDependents: '', // Reset numberOfDependents
      }));
      setIsIndividualChild(false);
    } else {
      // Otherwise, update formData normally
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }

    if (name === 'package' && value === 'Individual + Children') {
      setIsIndividualChildren(true);
    } else if (name === 'package') {
      setIsIndividualChildren(false);
    }


    // NUMBER OF DEPENDENTS CONDITIONS
    if (name === 'numberOfDependents') {
      setFormData(prevState => ({
        ...prevState,
        [name]: value,
        dependent1Age: '',
        dependent2Age: '',
        dependent3Age: '',
        dependent4Age: '',
        dependent5Age: '',
        dependent6Age: '',
        dependent7Age: '',
      }))
    }
  };

  useEffect(() => {
    setFormData({
      package: onlineQuoteForm.package,
      age: onlineQuoteForm.age,
      spouseAge: onlineQuoteForm.spouseAge,
      tobaccoUser: onlineQuoteForm.tobaccoUser,
      medications: onlineQuoteForm.medications,
      numberOfDependents: onlineQuoteForm.numberOfDependents,
      dependent1Age: onlineQuoteForm.dependent1Age,
      dependent2Age: onlineQuoteForm.dependent2Age,
      dependent3Age: onlineQuoteForm.dependent3Age,
      dependent4Age: onlineQuoteForm.dependent4Age,
      dependent5Age: onlineQuoteForm.dependent5Age,
      dependent6Age: onlineQuoteForm.dependent6Age,
      dependent7Age: onlineQuoteForm.dependent7Age,
    })
  }, [
    onlineQuoteForm.package,
    onlineQuoteForm.age,
    onlineQuoteForm.spouseAge,
    onlineQuoteForm.tobaccoUser,
    onlineQuoteForm.medications,
    onlineQuoteForm.numberOfDependents,
    onlineQuoteForm.dependent1Age,
    onlineQuoteForm.dependent2Age,
    onlineQuoteForm.dependent3Age,
    onlineQuoteForm.dependent4Age,
    onlineQuoteForm.dependent5Age,
    onlineQuoteForm.dependent6Age,
    onlineQuoteForm.dependent7Age,
  ]);

  useEffect(() => {
    setNumOfDependentsToRender(formData.numberOfDependents)
  }, [formData.numberOfDependents, setNumOfDependentsToRender]);

  useEffect(() => {
    dispatch(setOnlineQuoteForm(formData))
  }, [formData, dispatch]);

  const packageInvalid = showErrors && !formData.package;
  const ageNum = parseInt(formData.age, 10);
  const ageEmpty = showErrors && !String(formData.age || '').trim();
  const ageRangeInvalid = showErrors && Boolean(String(formData.age || '').trim()) && (isNaN(ageNum) || ageNum < 18 || ageNum > 64);
  const ageInvalid = ageEmpty || ageRangeInvalid;

  const needsSpouse = formData.package === "Couple" || formData.package === "Family";
  const spouseAgeNum = parseInt(formData.spouseAge, 10);
  const spouseAgeEmpty = showErrors && needsSpouse && !String(formData.spouseAge || '').trim();
  const spouseAgeRangeInvalid = showErrors && needsSpouse && Boolean(String(formData.spouseAge || '').trim()) && (isNaN(spouseAgeNum) || spouseAgeNum < 18 || spouseAgeNum > 64);
  const spouseAgeInvalid = spouseAgeEmpty || spouseAgeRangeInvalid;

  const tobaccoInvalid = showErrors && !formData.tobaccoUser;
  const needsDependents = formData.package && formData.package !== "Couple" && formData.package !== "Individual";
  const numDependentsInvalid = showErrors && needsDependents && !formData.numberOfDependents;
  const termsInvalid = showErrors && !agreeToTerms;


  return (
    <>

      {/* CLIENT */}

      <label className="form-control w-full px-2 py-1" data-invalid={packageInvalid ? "true" : undefined}>
        <div className="label py-[1px]">
          <span className="label-text">Package <span className="text-error">*</span></span>
          {packageInvalid && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Required</span>}
        </div>
        <select
          className={`select select-bordered w-full ${packageInvalid ? 'select-error border-2 border-red-600 bg-red-50' : ''}`}
          name="package"
          value={formData.package}
          onChange={handleInputChange}
        >
          <option disabled value="">Select Coverage Type</option>
          <option value="Individual">Individual</option>
          <option value="Couple">Couple</option>
          <option value="Family">Family</option>
          <option value="Individual + Child">Individual + Child</option>
          <option value="Individual + Children">Individual + Children</option>
        </select>
      </label>

      <label className="form-control w-full px-2 py-1" data-invalid={ageInvalid ? "true" : undefined}>
        <div className="label py-[1px]">
          <span className="label-text">Your Age (18–64) <span className="text-error">*</span></span>
          {ageEmpty && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Required</span>}
          {ageRangeInvalid && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Must be 18–64</span>}
        </div>
        <input
          type="number"
          placeholder="Your answer"
          className={`input input-sm input-bordered w-full ${ageInvalid ? 'input-error border-2 border-red-600 bg-red-50' : ''}`}
          name="age"
          min={18}
          max={64}
          value={formData.age}
          onChange={handleInputChange}
        />
      </label>

      {/* SPOUSE */}
      {
        formData.package === "Couple" || formData.package === "Family" ?
          <>
            <label className="form-control w-full px-2 py-1" data-invalid={spouseAgeInvalid ? "true" : undefined}>
              <div className="label py-[1px]">
                <span className="label-text">Spouse Age (18–64) <span className="text-error">*</span></span>
                {spouseAgeEmpty && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Required</span>}
                {spouseAgeRangeInvalid && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Must be 18–64</span>}
              </div>
              <input
                type="number"
                placeholder="Your answer"
                className={`input input-sm input-bordered w-full ${spouseAgeInvalid ? 'input-error border-2 border-red-600 bg-red-50' : ''}`}
                name="spouseAge"
                min={18}
                max={64}
                value={formData.spouseAge}
                onChange={handleInputChange}
              />
            </label>

          </>
          :
          null
      }

      <label className="form-control w-full px-2 py-1" data-invalid={tobaccoInvalid ? "true" : undefined}>
        <div className="label py-[1px]">
          <span className="label-text">Tobacco User? <span className="text-error">*</span></span>
          {tobaccoInvalid && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Required</span>}
        </div>
        <select
          className={`select select-bordered w-full ${tobaccoInvalid ? 'select-error border-2 border-red-600 bg-red-50' : ''}`}
          name="tobaccoUser"
          value={formData.tobaccoUser}
          onChange={handleInputChange}
        >
          <option disabled value="">Yes or No</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </label>

      <label className="form-control w-full px-2 py-1">
        <div className="label py-[1px]">
          <span className="label-text">Any Medications?</span>
        </div>
        <textarea
          className="textarea textarea-bordered"
          placeholder="List it down here..."
          name="medications"
          value={formData.medications}
          onChange={handleInputChange}
        />
      </label>

      <br />
      {/* DEPENDENTS */}
      {
        formData.package === "Couple"
          || formData.package === "Individual"
          || formData.package === "" ?
          null
          :
          <>
            <label className="form-control w-full px-2 py-1" data-invalid={numDependentsInvalid ? "true" : undefined}>
              <div className="label py-[1px]">
                <span className="label-text">Number of Dependents <span className="text-error">*</span></span>
                {numDependentsInvalid && <span className="text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded">Required</span>}
              </div>
              <select
                disabled={isIndividualChild}
                className={`select select-bordered w-full ${numDependentsInvalid ? 'select-error border-2 border-red-600 bg-red-50' : ''}`}
                name="numberOfDependents"
                value={formData.numberOfDependents}
                onChange={handleInputChange}
              >
                <option disabled value="">Select</option>
                {
                  !isIndividualChildren && <option value="1">1</option>
                }
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
              </select>
            </label>


            <div className='flex flex-col w-full gap-y-2 mt-2'>

              {
                formData.package === "Individual + Child" ?
                  <>
                    <label className="form-control w-full px-2 py-1">
                      <div className="label py-[1px]">
                        <span className="label-text">Dependent 1 Age</span>
                      </div>
                      <input
                        type="number"
                        placeholder="Your answer"
                        min={0}
                        max={150}
                        className="input input-sm input-bordered w-full"
                        name="dependent1Age"
                        value={formData.dependent1Age}
                        onChange={handleInputChange}
                      />
                    </label>
                  </>
                  :
                  <>
                    {
                      dependents.slice(0, numOfDependentsToRender).map((dependent) => (
                        <label className="form-control w-full px-2 py-1" key={dependent.name}>
                          <div className="label py-[1px]">
                            <span className="label-text">{dependent.label}</span>
                          </div>
                          <input
                            type="number"
                            placeholder="Your answer"
                            min={0}
                            max={150}
                            className="input input-sm input-bordered w-full"
                            name={dependent.name}
                            value={dependent.value}
                            onChange={handleInputChange}
                          />
                        </label>
                      ))
                    }
                  </>
              }

            </div>
          </>
      }


      {/* DISCLAIMER */}
      <label
        className={`label cursor-pointer flex items-start rounded-lg p-2 mt-2 ${termsInvalid ? 'border-2 border-red-600 bg-red-50' : ''}`}
        data-invalid={termsInvalid ? "true" : undefined}
      >
        <input
          type="checkbox"
          className={`checkbox rounded mr-4 mt-1 ${termsInvalid ? 'checkbox-error border-red-600' : ''}`}
          name="agreeToTerms"
          checked={agreeToTerms}
          onChange={handleAgreeToTerms}
        />
        <span className="label-text text-xs">
          {termsInvalid && (
            <span className="inline-block text-[11px] font-bold text-white bg-red-600 px-1.5 py-0.5 rounded mr-2 mb-1">
              Required: Please check to agree
            </span>
          )}
          By providing your email address and phone number, you agree to receive email and text messages from
          Insurance Enterprise USA about our products and services.
          Email or text HELP to
          <span className='underline text-blue-600 hover:text-blue-400 px-1'>
            <a href='mailto:benefits@insuranceenterpriseusa.com' rel='noreferrer'>
              benefits@insuranceenterpriseusa.com
            </a>
          </span>

          or
          <a href='tel:8883506605' rel='noreferrer' className='underline text-blue-600 hover:text-blue-400 px-1'>
            888-350-6605
          </a>
          for assistance. You can unsubscribe at any time
        </span>
      </label>

    </>
  );
}

export default Segment2;
